export enum AppNames {
    Operations = "operations",
    Marketing = "marketing",
    BrewMenu = "brewmenu",
    BrewKnowledge = "brew-knowledge",
    MediaLibrary = "media-library"
}
